// extracted by mini-css-extract-plugin
export default {"container":"ContactInfoBox_container__DWCR6","left":"ContactInfoBox_left__68RCj","right":"ContactInfoBox_right__pm1Oy"};